function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import clsx from 'clsx';
import { Avatar, Card, CardHeader, CardContent, CardActions, Typography } from '@material-ui/core';
import { useStyles } from "./styles.js";
export const TestimonialCard = ({
  personImg,
  personName,
  personCharge,
  companyLogo,
  testimonial,
  elevation,
  aosProps,
  background,
  style,
  cardClassName,
  avatarClassName
}) => {
  const classes = useStyles({
    background
  });
  return /*#__PURE__*/React.createElement(Card, _extends({}, aosProps, {
    elevation: elevation,
    className: clsx(classes.card, cardClassName),
    style: style
  }), /*#__PURE__*/React.createElement(CardHeader, {
    avatar: /*#__PURE__*/React.createElement(Avatar, {
      alt: personName,
      "aria-label": "author",
      src: personImg,
      className: clsx(classes.avatar, avatarClassName)
    }),
    subheader: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      align: "left",
      className: classes.personName
    }, personName), /*#__PURE__*/React.createElement(Typography, {
      align: "left",
      className: classes.personCharge
    }, personCharge))
  }), /*#__PURE__*/React.createElement(CardContent, {
    className: classes.cardContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "p",
    className: classes.testimonial
  }, `"${testimonial}"`)), /*#__PURE__*/React.createElement(CardActions, {
    className: classes.cardActions
  }, /*#__PURE__*/React.createElement("img", {
    alt: "company logo",
    src: companyLogo,
    className: classes.companyLogo
  })));
};
TestimonialCard.defaultProps = {
  elevation: 6,
  aosProps: {
    'data-aos': 'fade-up',
    'data-aos-once': 'true'
  }
};
TestimonialCard.displayName = 'TestimonialCard';
export default TestimonialCard;